import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import RichTextDisplay from 'Components/UI/Overrides/RichTextDisplay';
import { TitleTextMedium } from 'Packages/FacetDesign/Components';
import { FDWizardSubtitle } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper/Layout/FDWizardSubtitle';

export const MissingAccountsAndRealAssetOverride = buildFacetDesignOverride()
  .nameOverride('content', {
    _component: () => RichTextDisplay,
    hidden: false,
  })
  .nameOverride('contentTitle', { _component: () => TitleTextMedium }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDWizardSubtitle,
  }, overrideReadOnly);
